import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Smooth-scroll to the in-page anchor when a route changes to a #hash.
// react-router-dom does not do this by default.
export default function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: 'auto' });
      return;
    }
    const id = hash.replace(/^#/, '');
    requestAnimationFrame(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }, [pathname, hash]);

  return null;
}
